import React from 'react';
import PropTypes from 'prop-types';
import { Ellipsis } from 'react-spinners-css';

const AuthSubmitButton = props => {
  return (
    <div className="field">
      <div className="control">
        <button className="tutorium-btn-submit" type="submit">
          {!props.isSubmitting && <span>{props.title}</span>}
          {props.isSubmitting && <Ellipsis color="white" size={39} />}
        </button>
      </div>
    </div>
  );
};

AuthSubmitButton.propTypes = {
  title: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default AuthSubmitButton;
